// extracted by mini-css-extract-plugin
module.exports = {"icon":"DownloadFile_icon__5sQ3X","download":"DownloadFile_download__t_EtA"};